import { getStore } from '~/mobx/AppStore';
import mediaApi from '~/clientApis/mediaApi';
import { Candidate } from '~/definitions/candidates';
import { showMessageModal } from '~/clientUtils/showMessageModal';

const fetchCandidatePhoto = async () => {
    const { candidateStore } = getStore();
    const selectedCandidate = candidateStore.getSelectedCandidate() as Candidate;

    if (!selectedCandidate) return;

    const mediaId = selectedCandidate.picture;
    candidateStore.setIsFetchingCandidatePhoto(true);
    try {
        const media = await mediaApi.getMediaById(mediaId, {
            size: 'CANDIDATE_PHOTO',
        });
        candidateStore.setCandidatePhoto(media);
    } catch {
        showMessageModal('error', 'Feil ved henting av kandidatbilde');
        candidateStore.setCandidatePhoto({
            name: '',
            url: '',
        });
    } finally {
        candidateStore.setIsFetchingCandidatePhoto(false);
    }
};

export default fetchCandidatePhoto;
